import api from './utilBackoffice';

const controller = 'RecebimentoArquivo';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },

  Download: (dto, fileName) => {
    return api.Axios.DownloadZipFile(url + '/Download', dto, fileName);
  },

  BuscarErroArquivoResposta: dto => {
    return api.Axios.GetParams(url + '/BuscaRespostaErro', dto);
  }
});
